import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FuseFullscreenComponent } from '../../../../../@fuse/components/fullscreen';
import { FuseVerticalNavigationComponent } from '../../../../../@fuse/components/navigation';
import { LanguagesModule } from '../../../common/languages/languages.module';
import { DenseLayoutComponent } from './dense.component';
import { CommonModule } from '@angular/common';
import { UserModule } from '../../../common/user/user.module';
import { TenantModule } from '../../../common/tenant/tenant.module';

@NgModule({ declarations: [DenseLayoutComponent],
    exports: [DenseLayoutComponent], imports: [CommonModule,
        RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        FuseFullscreenComponent,
        FuseVerticalNavigationComponent,
        LanguagesModule,
        UserModule,
        TenantModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class DenseLayoutModule {}
